import { buttonMessages } from "@saleor/intl";
import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";

const {
  ACKNOWLEDGED,
  CANCELED,
  NEW_ORDER,
  READY,
  COLLECTED,
  RECEIVED_AT_FC,
  PACKED,
  READY_TO_SHIP,
  SHIPPED
} = SmopOrderStatusEnum;

const { STORE_ADMIN, OMI_OPS, RUNNER, OMI_FINANCE } = SmopUserTypeCode;
const {
  EXPRESS,
  EXPRESS_LONG_DISTANCE,
  IN_STORE_PICKUP,
  SAME_DAY
} = DeliveryTypeEnum;

export const handleCancelModal = (
  userType: SmopUserTypeCode,
  shippingMethod: DeliveryTypeEnum,
  smopStatus: SmopOrderStatusEnum,
  isMultiTenant: boolean,
  enableManageMallActions: boolean,
  notify,
  onModal
) => {
  const isStoreAdmin = userType === STORE_ADMIN;
  const isOpsAdmin = userType === OMI_OPS;

  if (isStoreAdmin || isOpsAdmin || enableManageMallActions) {
    if (
      isStoreAdmin &&
      smopStatus === ACKNOWLEDGED &&
      (shippingMethod === EXPRESS ||
        shippingMethod === EXPRESS_LONG_DISTANCE ||
        shippingMethod === IN_STORE_PICKUP ||
        shippingMethod === SAME_DAY)
    ) {
      notify({
        status: "error",
        text: "Unable to cancel. This order is already acknowledged."
      });
    } else if (isStoreAdmin && smopStatus === READY) {
      notify({
        status: "error",
        text: "Unable to cancel. This order is already marked as ready."
      });
    } else if (isStoreAdmin && smopStatus === COLLECTED) {
      notify({
        status: "error",
        text: "Unable to cancel. This order is already marked as collected."
      });
    } else if (isStoreAdmin && smopStatus === RECEIVED_AT_FC) {
      notify({
        status: "error",
        text:
          "Unable to cancel. This order is already marked as received at FC."
      });
    } else if (isStoreAdmin && smopStatus === PACKED) {
      notify({
        status: "error",
        text: "Unable to cancel. This order is already packed."
      });
    } else if (isStoreAdmin && smopStatus === READY_TO_SHIP) {
      notify({
        status: "error",
        text: "Unable to cancel. This order is already ready to ship."
      });
    } else if (isStoreAdmin && smopStatus === SHIPPED) {
      notify({
        status: "error",
        text: "Unable to cancel. This order is already ready to shipped."
      });
    } else if (isStoreAdmin && isMultiTenant) {
      notify({
        status: "error",
        text:
          "Unable to cancel. This is a multi-tenant order. To cancel, please contact the Operations team."
      });
    } else {
      onModal("cancel");
    }
  } else {
    notify({
      status: "error",
      text:
        "Unable to cancel. Only the store admin and ops admin can cancel an order."
    });
  }
};

export const hideSaveButton = (
  userType: SmopUserTypeCode,
  smopStatus: SmopOrderStatusEnum,
  shippingMethod: DeliveryTypeEnum,
  paymentMethod: string,
  enableManageMallActions: boolean
) => {
  switch (smopStatus) {
    case NEW_ORDER:
    case ACKNOWLEDGED:
      if (userType === STORE_ADMIN) {
        return false;
      } else if (
        (userType === OMI_OPS || enableManageMallActions) &&
        shippingMethod !== IN_STORE_PICKUP
      ) {
        return false;
      } else {
        return true;
      }
    case READY:
      // If delivery type is "in-mall pickup", only show button to ops admin
      if (
        shippingMethod === IN_STORE_PICKUP &&
        (userType === OMI_OPS ||
          userType === STORE_ADMIN ||
          enableManageMallActions)
      ) {
        return false;
      }
      // If delivery type is "express/next-day delivery", only show button to runner and ops admin
      if (
        (shippingMethod !== IN_STORE_PICKUP && userType === RUNNER) ||
        userType === OMI_OPS ||
        enableManageMallActions
      ) {
        return false;
      }
      return true;
    case COLLECTED:
      if (userType === OMI_OPS || enableManageMallActions) {
        if (
          shippingMethod === EXPRESS ||
          shippingMethod === EXPRESS_LONG_DISTANCE ||
          shippingMethod === SAME_DAY
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    case CANCELED:
      if (
        ([OMI_OPS, OMI_FINANCE].includes(userType) ||
          enableManageMallActions) &&
        paymentMethod !== "gcash"
      ) {
        return false;
      }
      break;

    default:
      return true;
  }
};

export const checkAction = (
  userType: SmopUserTypeCode,
  smopStatus: SmopOrderStatusEnum,
  confirmDialog: (smopStatus: any) => void,
  overrideStatusDialog: () => void,
  reverseCancelDialog: () => void,
  enableManageMallActions: boolean
) => {
  switch (smopStatus) {
    case NEW_ORDER:
    case ACKNOWLEDGED:
      if (userType === STORE_ADMIN) {
        confirmDialog(smopStatus);
      } else if (userType === OMI_OPS || enableManageMallActions) {
        overrideStatusDialog();
      }
      break;
    case COLLECTED:
      confirmDialog(smopStatus);
      break;
    case READY:
      confirmDialog(smopStatus);
      break;
    case CANCELED:
      reverseCancelDialog();
  }
};

export const handleLabelButton = (
  smopStatus: SmopOrderStatusEnum,
  shippingMethod: DeliveryTypeEnum,
  intl
) => {
  switch (smopStatus) {
    case NEW_ORDER:
      return intl.formatMessage(buttonMessages.acknowledge);
    case ACKNOWLEDGED:
      return intl.formatMessage(buttonMessages.ready);
    case READY:
      if (shippingMethod === IN_STORE_PICKUP) {
        return intl.formatMessage(buttonMessages.completed);
      }
      return intl.formatMessage(buttonMessages.collect);
    case COLLECTED:
      return intl.formatMessage(buttonMessages.receivedAtFc);
    case CANCELED:
      return intl.formatMessage(buttonMessages.reverseCancellation);
    default:
      return intl.formatMessage(buttonMessages.save);
  }
};
